
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","height":"48","width":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('navigation-menu-2')]),_c('rect',{attrs:{"x":"6.75","y":"0.753","width":"16.5","height":"4.5","rx":"1.5","ry":"1.5","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('rect',{attrs:{"x":"3.75","y":"9.753","width":"16.5","height":"4.5","rx":"1.5","ry":"1.5","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('rect',{attrs:{"x":"0.75","y":"18.753","width":"16.5","height":"4.5","rx":"1.5","ry":"1.5","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}})])
          )
        }
      }
    